module.exports = __webpack_public_path__ + "static/media/icons8-line.19825023.svg";